import React from 'react';
import { Link } from 'react-router-dom';

import './styles.scss';

function PopUP () {
  return (
    <div className="popup__container">
      <div className="popup__close">
        <span>
          <Link to="/hires" className="button__link">X</Link>
        </span>
      </div>
      <div className="popup__circle">
        <div className="popup__content">
          <h3 className="popup__title">inigualable</h3>
          <h4 className="popup__text">tv interactiva + telefonía fija a un precio <span>increíble</span></h4>
          <input className="popup__input" placeholder="tu teléfono"></input>
          <div className="privacy">
            <input type="checkbox" id="privacy__text" name="privacy__text" />
            <label className="privacy__text" for="privacy__text">he leído y acepto las políticas de privacidad.</label>
          </div>
          <button className="call__button">
            <Link to="/hires" className="button__link">llámenme</Link>
          </button>
        </div>
      </div>
    </div>
  );
}

export default PopUP;
